// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"649":"1a688927","671":"e2a48703","700":"0b82f834","761":"45fb30e1","940":"d76038cd"}[chunkId] + ".chunk.css";
};